export enum PageUrlSegment {
  HOMEPAGE = '',
  TRANSFER_LANDING = '/transfer/checkout',
  TRANSFER_ADD_MEMBERSHIP = '/transfer/checkout/membership',
  TRANSFER_REVIEW = '/transfer/review',
  TRANSFER_PROGRAMS = '/transfer/programs',
  TRANSFER_SUCCESS = '/transfer/success',
  POINTS_TRANSACTIONS = '/points_activity',
}
